var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
export default class PropStateStore {
    constructor(props) {
        Object.defineProperty(this, "isEmbedded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isSsr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "etLangPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ruLangPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "showEnLang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "forceSegment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setEtLangPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                this.etLangPath = path;
            }
        });
        Object.defineProperty(this, "setRuLangPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (path) => {
                this.ruLangPath = path;
            }
        });
        Object.defineProperty(this, "setShowEnLang", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isShown) => {
                this.showEnLang = isShown;
            }
        });
        Object.defineProperty(this, "setIsEmbedded", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isEmbedded) => {
                this.isEmbedded = isEmbedded;
            }
        });
        Object.defineProperty(this, "setIsSsr", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (isSsr) => {
                this.isSsr = isSsr;
            }
        });
        Object.defineProperty(this, "setForceSegment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (forceSegment) => {
                this.forceSegment = forceSegment;
            }
        });
        makeObservable(this);
        const { isEmbedded, isSSR, etLangPath, ruLangPath, showEnLang, forceSegment } = props;
        this.setIsEmbedded(isEmbedded);
        this.setIsSsr(isSSR);
        this.setEtLangPath(etLangPath);
        this.setRuLangPath(ruLangPath);
        this.setShowEnLang(showEnLang);
        this.setForceSegment(forceSegment);
    }
}
__decorate([
    observable
], PropStateStore.prototype, "isEmbedded", void 0);
__decorate([
    observable
], PropStateStore.prototype, "isSsr", void 0);
__decorate([
    observable
], PropStateStore.prototype, "etLangPath", void 0);
__decorate([
    observable
], PropStateStore.prototype, "ruLangPath", void 0);
__decorate([
    observable
], PropStateStore.prototype, "showEnLang", void 0);
__decorate([
    observable
], PropStateStore.prototype, "forceSegment", void 0);
__decorate([
    action
], PropStateStore.prototype, "setEtLangPath", void 0);
__decorate([
    action
], PropStateStore.prototype, "setRuLangPath", void 0);
__decorate([
    action
], PropStateStore.prototype, "setShowEnLang", void 0);
__decorate([
    action
], PropStateStore.prototype, "setIsEmbedded", void 0);
__decorate([
    action
], PropStateStore.prototype, "setIsSsr", void 0);
__decorate([
    action
], PropStateStore.prototype, "setForceSegment", void 0);
//# sourceMappingURL=PropStateStore.js.map